// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1__e4af3b353c2b6a6a1c6d","cls2":"AuthorHeader-cls2___66ff57e4a4d74b4a74a AuthorHeader-cls1__e4af3b353c2b6a6a1c6d"};